module.exports = __webpack_public_path__ + "assets/metagenerator.e0d4813c.svg";